import {ICrsConverter} from "./ICrsConverter";

export class CrsConverter implements ICrsConverter {
    private map: ICrsMap = {};

    constructor(domNode: HTMLElement) {
        this.map = JSON.parse(domNode.innerHTML) as ICrsMap;
    }

    public mapToName(crs: string): string {
        if (crs in this.map) return this.map[crs];
        return "Unknown";
    }
}

interface ICrsMap {
    [crsKey: string]: string;
}
